export const backgroundMenuColor = "#ffffff";
export const backgroundHeaderColor = "#1378c6";